import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import landingLogo from '../assets/logo.png';
import '../App.css'; // Ensure global styles are available

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavClick = (targetId) => {
    // If on landing page, scroll to section
    if (location.pathname === "/") {
      const element = document.getElementById(targetId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      } else {
        // Fallback if element not found (e.g., might need to allow time for render if needed, but usually fine)
        window.scrollTo(0, 0);
      }
    } else {
      // Navigate to landing page with target state
      navigate("/", { state: { target: targetId } });
    }
  };

  const handlePageNav = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
  };

  return (
    <footer className="footer-improved">
      <div className="footer-top">
        <div className="footer-brand">
          <a onClick={() => handleNavClick("home")} className="logo-brand" style={{ marginBottom: "1rem", display: "inline-flex", cursor: "pointer" }}>
            <img src={landingLogo} alt="Moonshot Logo" className="nav-logo-img" />
            <span className="logo-text" style={{ color: "#000000" }}>MoonShotMap</span>
          </a>
          <p>
            The operating system for early-stage clarity. Stop guessing, start
            mapping.
          </p>
        </div>

        <div className="footer-links-group">
          <div className="link-column">
            <h4>Platform</h4>
            <a onClick={() => handleNavClick("engine")} style={{ cursor: "pointer" }}>The Engine</a>
            <a onClick={() => handlePageNav("/how-to-use")} style={{ cursor: "pointer" }}>How to Use</a>
            <a onClick={() => handlePageNav("/pricing")} style={{ cursor: "pointer" }}>Pricing</a>
          </div>
          <div className="link-column">
            <h4>Resources</h4>
            {/* These define external links or placeholders for now */}
            <a onClick={() => handlePageNav("/founder-guide")} style={{ cursor: "pointer" }}>Founder Guides</a>
            {/* <a href="#" onClick={(e) => e.preventDefault()}>Sample Maps</a> */}
            <a onClick={() => handlePageNav("/blog")} style={{ cursor: "pointer" }}>Blog</a>
          </div>
          <div className="link-column">
            <h4>Legal</h4>
            <a onClick={() => handlePageNav("/privacy")} style={{ cursor: "pointer" }}>Privacy Policy</a>
            <a onClick={() => handlePageNav("/terms")} style={{ cursor: "pointer" }}>Terms Of Use</a>
            <a onClick={() => handlePageNav("/security")} style={{ cursor: "pointer" }}>Security</a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p style={{ color: "var(--text-secondary)", fontSize: "0.9rem" }}>
          &copy; Copyright - MoonShotMap - 2026
        </p>
        <div className="social-links">
          {/* X (formerly Twitter) */}
          <a href="https://x.com/moonshotmap" target="_blank" rel="noreferrer" className="social-icon">
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              {/* X Logo Path */}
              <path d="M4 4l11.733 16h4.267l-11.733-16z" />
              <path d="M4 20l6.768-9.228" />
              <path d="M20 4l-6.768 9.228" />
            </svg>
          </a>
          {/* LinkedIn */}
          <a href="https://www.linkedin.com/company/moonshotmap/about/?viewAsMember=true" target="_blank" rel="noreferrer" className="social-icon">
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
              <rect x="2" y="9" width="4" height="12" />
              <circle cx="4" cy="4" r="2" />
            </svg>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
